// główne filtry listy produktów

import React, { FC } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import classnames from 'classnames';

import { IProductsFilter, IProductsFilterValue } from 'api/types';
import { Range } from 'components/controls';
import WiseSelect from 'components/wise/WiseSelect';

import { XIcon } from 'assets/icons';

import styles from 'theme/pages/Products/components/FiltersTopBar/FiltersTopBar.module.scss';

interface IFilter {
  filter_id: string;
  filter_value: string;
}

// typ danych wejściowych
interface IProps {
  queryFilters: IFilter[];
  onChange: (filters: IFilter[]) => void;
  filtersData?: IProductsFilter[];
}

const FiltersTopBar: FC<IProps> = ({ onChange, queryFilters, filtersData }) => {
  const { t } = useTranslation();

  const renderFilterType = (filter: IProductsFilter) => {
    if (filter.type === 'singlechoice') {
      return (
        <WiseSelect<IProductsFilterValue>
          value={queryFilters.find((item) => item.filter_id === filter.id)?.filter_value}
          onChange={(item) =>
            onChange([
              ...queryFilters.filter((assignedFilter) => assignedFilter.filter_id !== filter.id),
              ...(item ? [{ filter_id: filter.id, filter_value: item.value }] : [])
            ])
          }
          options={filter.values.map((item) => ({
            value: item.value,
            label: item.name,
            item
          }))}
          placeholder={filter.label}
          clearable
        />
      );
    }

    if (filter.type === 'range') {
      return (
        <Range
          onChange={onChange}
          queryFilters={queryFilters}
          filter={{
            ...filter,
            values: filter.values
          }}
        />
      );
    }

    return (
      <div className={styles.unknownType}>
        {t('Nieznany typ filtra')} (<strong>{filter.type}</strong>)
      </div>
    );
  };

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Products-components-FiltersTopBar'
      )}>
      <div className={styles.filtersWrapper}>
        {filtersData?.map((filter) => (
          <React.Fragment key={filter.id}>{renderFilterType(filter)}</React.Fragment>
        ))}
        {!!queryFilters.length && (
          <button className={styles.clearButton} onClick={() => onChange([])}>
            <XIcon />
            <span>
              <Trans>usuń wszystkie</Trans>
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default FiltersTopBar;
